var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('img',{attrs:{"src":"https://umed.oss-cn-hangzhou.aliyuncs.com/say/top.png","alt":"top"}})])
}]

export { render, staticRenderFns }